(function () {
  'use strict';

  var MOINS_DE_MOUVEMENT = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : { matches: false };

  function demarrer(racine) {
    var piste = racine.querySelector('[data-cm-h-piste]');
    if (!piste) return;

    var vues = Array.prototype.slice.call(piste.querySelectorAll('[data-cm-h-vue]'));
    if (vues.length < 2) {

      racine.classList.add('cm-h-live--seule');
      return;
    }

    var prec = racine.querySelector('[data-cm-h-prec]');
    var suiv = racine.querySelector('[data-cm-h-suiv]');
    var pause = racine.querySelector('[data-cm-h-pause]');
    var points = racine.querySelector('[data-cm-h-points]');
    var delai = parseInt(racine.getAttribute('data-cm-h-delai'), 10) || 4000;
    var automatique = racine.getAttribute('data-cm-h-auto') === 'true' && !MOINS_DE_MOUVEMENT.matches;

    var minuteur = null;
    var arrete = false;
    var suspendu = false;

    function glisser(x) {
      piste.scrollTo({ left: x, behavior: MOINS_DE_MOUVEMENT.matches ? 'auto' : 'smooth' });
    }

    var arrets = [];

    function calculerArrets() {
      var max = Math.max(0, piste.scrollWidth - piste.clientWidth);
      var out = [];
      for (var i = 0; i < vues.length; i++) {
        var x = vues[i].offsetLeft - piste.offsetLeft;
        if (x >= max) break;
        out.push(x);
      }
      out.push(max);

      arrets = out.filter(function (x, i) { return i === 0 || Math.abs(x - out[i - 1]) > 2; });
      if (!arrets.length) arrets = [0];
    }

    function index() {
      var gauche = piste.scrollLeft;
      var meilleur = 0;
      var ecartMin = Infinity;
      for (var i = 0; i < arrets.length; i++) {
        var ecart = Math.abs(arrets[i] - gauche);
        if (ecart < ecartMin) { ecartMin = ecart; meilleur = i; }
      }
      return meilleur;
    }

    function allerA(i) {
      var n = arrets.length;
      glisser(arrets[((i % n) + n) % n]);
    }

    function majPoints() {
      if (!points) return;
      var courant = index();
      var boutons = points.querySelectorAll('button');
      for (var i = 0; i < boutons.length; i++) {
        var actif = i === courant;
        boutons[i].classList.toggle('est-actif', actif);
        boutons[i].setAttribute('aria-current', actif ? 'true' : 'false');
      }
    }

    function tour() {
      if (arrete || suspendu) return;
      allerA(index() + 1);
    }

    function relancer() {
      if (minuteur) { clearInterval(minuteur); minuteur = null; }
      if (automatique && !arrete) minuteur = setInterval(tour, delai);
    }

    if (prec) prec.addEventListener('click', function () { allerA(index() - 1); });
    if (suiv) suiv.addEventListener('click', function () { allerA(index() + 1); });

    function construirePoints() {
      if (!points) return;
      points.textContent = '';
      for (var i = 0; i < arrets.length; i++) {
        (function (n) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'cm-h-live__point';
          b.setAttribute('aria-label', (points.getAttribute('data-cm-h-libelle') || 'Photo') + ' ' + (n + 1));
          b.addEventListener('click', function () { allerA(n); });
          points.appendChild(b);
        })(i);
      }
    }

    if (pause) {
      pause.addEventListener('click', function () {
        arrete = !arrete;
        pause.setAttribute('aria-pressed', arrete ? 'true' : 'false');
        pause.setAttribute('aria-label', arrete
          ? (pause.getAttribute('data-cm-h-reprendre') || 'Reprendre le défilement')
          : (pause.getAttribute('data-cm-h-arreter') || 'Arrêter le défilement'));
        racine.classList.toggle('cm-h-live--arrete', arrete);
        relancer();
      });

      if (!automatique) pause.remove();
    }

    ['mouseenter', 'focusin', 'pointerdown'].forEach(function (e) {
      racine.addEventListener(e, function () { suspendu = true; });
    });
    ['mouseleave', 'focusout'].forEach(function (e) {
      racine.addEventListener(e, function () {
        if (!racine.contains(document.activeElement) && !racine.matches(':hover')) suspendu = false;
      });
    });
    document.addEventListener('visibilitychange', function () {
      suspendu = document.hidden;
    });

    var attente = null;
    piste.addEventListener('scroll', function () {
      if (attente) return;
      attente = requestAnimationFrame(function () { attente = null; majPoints(); });
    }, { passive: true });

    if (MOINS_DE_MOUVEMENT.addEventListener) {
      MOINS_DE_MOUVEMENT.addEventListener('change', function () {
        automatique = racine.getAttribute('data-cm-h-auto') === 'true' && !MOINS_DE_MOUVEMENT.matches;
        relancer();
      });
    }

    calculerArrets();
    construirePoints();
    majPoints();
    relancer();

    var attenteTaille = null;
    window.addEventListener('resize', function () {
      if (attenteTaille) clearTimeout(attenteTaille);
      attenteTaille = setTimeout(function () {
        var avant = arrets.length;
        calculerArrets();
        if (arrets.length !== avant) construirePoints();
        majPoints();
      }, 150);
    });
  }

  function init() {
    var liste = document.querySelectorAll('[data-cm-h-carrousel]');
    for (var i = 0; i < liste.length; i++) demarrer(liste[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
